import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Flame, ArrowRight } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

const T = {
  es: "🎓 Estudia y gana $R₿L · Completa capítulos y recibe recompensas reales · 5% se quema ayudando al ecosistema",
  en: "🎓 Study and earn $R₿L · Complete chapters and receive real rewards · 5% is burned helping the ecosystem",
  sk: "🎓 Študuj a zarábaj $R₿L · Dokonči kapitoly a dostávaj skutočné odmeny · 5% sa spáli pomáhajúc ekosystému", de: "🎓 Lerne und verdiene $R₿L · Schließe Kapitel ab und erhalte echte Belohnungen · 5% werden verbrannt und helfen dem Ökosystem", "zh-CN": "🎓 学习并赚取 $R₿L · 完成章节并获得真实奖励 · 5% 销毁以帮助生态系统",
};

const CTA = {
  es: "Cómo funciona",
  en: "How it works",
  sk: "Ako to funguje", de: "Wie es funktioniert", "zh-CN": "如何运作",
};

export const LearnEarnBanner = () => {
  const { lang } = useLanguage();
  const text = T[lang] || T.en || T.es;
  const cta = CTA[lang] || CTA.en || CTA.es;

  return (
    <Link
      to="/learn-to-earn"
      className="group relative my-3 block overflow-hidden rounded-xl border-l-[3px] border-orange-500 bg-gradient-to-r from-orange-500/10 via-orange-500/[0.04] to-transparent px-4 py-3 backdrop-blur transition-all hover:from-orange-500/15 hover:to-orange-500/[0.06] hover:shadow-[0_0_24px_rgba(249,115,22,0.18)]"
      data-testid="learn-earn-banner"
    >
      <div className="flex items-center gap-3">
        <div className="hidden h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-orange-500/15 ring-1 ring-orange-400/30 sm:flex">
          <GraduationCap className="h-5 w-5 text-orange-300" />
        </div>
        <p className="flex-1 text-xs leading-relaxed text-white/85 sm:text-sm">
          {text}
        </p>
        <span className="ml-2 inline-flex shrink-0 items-center gap-1 rounded-full border border-orange-400/40 bg-orange-500/10 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-orange-200 transition-transform group-hover:translate-x-0.5">
          <Flame className="h-3 w-3" /> {cta}
          <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
};

export default LearnEarnBanner;
